export default __webpack_public_path__ + "static/media/26-Enchantment.ac7120e3.jpeg";